exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-manage[data-v-f4008c86]{position:absolute;width:calc(100% - 200px);left:200px;top:0;height:100vh;background:#f5f5f5;overflow:hidden}.container-manage-thin-menu[data-v-f4008c86]{position:absolute;width:calc(100% - 50px);left:50px;top:0;height:100vh;background:#f5f5f5;overflow:hidden}.header-box[data-v-f4008c86]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%;height:60px;background:#fff;padding:0 16px;border-bottom:1px solid #e5e5e5}.header-box[data-v-f4008c86],.header-menu[data-v-f4008c86]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4008c86","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/Report/ReportMainView.vue
// module id = 6UbO
// module chunks = 3